import React from 'react';
import { useScroll, useTransform } from 'framer-motion';
import HeroSection from '../components/HeroSection';
import ImpactOverview from '../components/ImpactOverview';
import AboutSection from '../components/AboutSection';
import FloraFaunaSection from '../components/FloraFaunaSection';
import TravelSection from '../components/TravelSection';
import PublicationSection from '../components/PublicationSection';
import NewsSection from '../components/NewsSection';
import CollaborationSection from '../components/CollaborationSection';
import Footer from '../components/Footer';

/* Asset Constants - Modern Environmental Collection */
const ASSETS = {
    SLIDESHOW: [
        {
            image: "https://lh3.googleusercontent.com/pw/AP1GczMahPZTsz3Hj18HOj1o-25fggP-2AySrym2iuWiBZfzRiGgesagxQwRxpBQr8_ckzowK6Hv42HUOOnv4SDGGeUle5eFZqcG5NBpORLZrtzQx7Z33dfqD0j-tgXfpwIbUb3HnSHklI_cKHDiXnlI5uCS=w1266-h869-s-no-gm?authuser=0",
            title: "Protecting Our Environment",
            highlight: "Through Education",
            description: "Join our mission to conserve natural resources and educate the next generation about the importance of ecological balance and sustainability."
        },
        {
            image: "https://lh3.googleusercontent.com/pw/AP1GczPV1X9DN_0II6jhvb0zOfaLJerVJvz4ihD4Plcvvlq6DeGAOVdZg4yGLpimS0ZwQ1mzrV10LF-Z3ZdfZ3MYCYqbOVa9g_agEKp0DzSwQEcBgZHBFY9y0GdxNjj1fme-gGHXVEeO96lHdwkhgCLmeY8MoQ=w1266-h869-s-no-gm?authuser=0",
            title: "Discover Botanical Wonders",
            highlight: "In Nature",
            description: "Explore our vast collection of scientific publications and botanical archives dedicated to flora and fauna conservation."
        },
        {
            image: "https://lh3.googleusercontent.com/pw/AP1GczPV1X9DN_0II6jhvb0zOfaLJerVJvz4ihD4Plcvvlq6DeGAOVdZg4yGLpimS0ZwQ1mzrV10LF-Z3ZdfZ3MYCYqbOVa9g_agEKp0DzSwQEcBgZHBFY9y0GdxWNj1fme-gGHXVEeO96lHdwkhgCLmeY8MoQ=w1266-h869-s-no-gm?authuser=0",
            title: "Travel With Purpose",
            highlight: "Sustainability First",
            description: "Embark on guided journeys through endangered ecosystems and learn how to travel responsibly while making a positive impact."
        },
        {
            image: "https://lh3.googleusercontent.com/pw/AP1GczPV1X9DN_0II6jhvb0zOfaLJerVJvz4ihD4Plcvvlq6DeGAOVdZg4yGLpimS0ZwQ1mzrV10LF-Z3ZdfZ3MYCYqbOVa9g_agEKp0DzSwQEcBgZHBFY9y0GdxWNj1fme-gGHXVEeO96lHdwkhgCLmeY8MoQ=w1266-h869-s-no-gm?authuser=0",
            title: "Scientific Outreach",
            highlight: "Future Generations",
            description: "We bridge the gap between complex research and public awareness to inspire a more sustainable world for everyone."
        },
        {
            image: "https://lh3.googleusercontent.com/pw/AP1GczPV1X9DN_0II6jhvb0zOfaLJerVJvz4ihD4Plcvvlq6DeGAOVdZg4yGLpimS0ZwQ1mzrV10LF-Z3ZdfZ3MYCYqbOVa9g_agEKp0DzSwQEcBgZHBFY9y0GdxWNj1fme-gGHXVEeO96lHdwkhgCLmeY8MoQ=w1266-h869-s-no-gm?authuser=0",
            title: "Join the Legacy",
            highlight: "Conserve Today",
            description: "Become part of a global movement dedicated to protecting the earth's most precious natural resources and biodiversity."
        }
    ],
};

const Home = () => {
    const { scrollYProgress } = useScroll();
    const scale = useTransform(scrollYProgress, [0, 0.2], [1, 0.95]);
    const opacity = useTransform(scrollYProgress, [0, 0.15], [1, 0]);

    return (
        <div className="relative isolate overflow-hidden bg-black selection:bg-emerald-500/20">
            {/* Dynamic Mesh Background Overlay */}
            <div className="fixed inset-0 -z-20 pointer-events-none overflow-hidden opacity-30">
                <div className="absolute top-[-10%] left-[-10%] w-[100%] h-[100%] rounded-full bg-emerald-900/40 blur-[150px] animate-pulse" />
            </div>

            <main>
                <HeroSection
                    scale={scale}
                    opacity={opacity}
                    slides={ASSETS.SLIDESHOW}
                />

                <FloraFaunaSection />
                <PublicationSection />
                <AboutSection />
                <NewsSection />
                <TravelSection />
                {/* <AboutSection /> */}
                <CollaborationSection />
                <ImpactOverview />
            </main>

            <Footer />
        </div>
    );
};

export default Home;
